module.exports = __webpack_public_path__ + "img/master.1e55e8dc.svg";